"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonToggle = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Button.css");
require("./ButtonToggle.css");
var _excluded = ["name", "value", "onChange", "size", "variant", "className", "children", "disabled"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 *
 * @typedef {object} ButtonToggleOwnProps
 * @prop {string} name
 * @prop {boolean} value
 * @prop {(checked: boolean) => void} onChange
 * @prop {import('./Button').ButtonOwnProps['size']} size
 * @prop {import('./Button').ButtonOwnProps['variant']} variant
 *
 *
 * @param {ButtonToggleOwnProps & React.HTMLProps<HTMLLabelElement>} props
 * @returns
 */
var ButtonToggle = exports.ButtonToggle = function ButtonToggle(_ref) {
  var name = _ref.name,
    value = _ref.value,
    _onChange = _ref.onChange,
    size = _ref.size,
    variant = _ref.variant,
    className = _ref.className,
    children = _ref.children,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("label", {
    role: "button",
    className: (0, _classnames["default"])('ap-button', 'ap-button--toggle', "ap-button--".concat(size), "ap-button--".concat(variant), className)
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "checkbox",
    name: name,
    checked: value,
    onChange: function onChange() {
      return _onChange(!value);
    },
    disabled: disabled
  }, props)), children);
};